
// @vue/component
export default {
    name: 'SurveyChartsSearchPanel',

    components: {
    },
    props: {
        surveysList: {
          type: Array,
          default: [],
        },
    },
    data() {
        return {
            searchParams: {
                uuid: '',
                date: [],
            },
            rules: {
                uuid: [
                  { required: true, message: 'Wybierz ankiete.', trigger: 'blur' },
                ],
                date: [
                  { required: true, message: 'Data jest wymagana.', trigger: 'blur' },
                ],
              },
            pickerOptions: { firstDayOfWeek: 1, disabledDate: this.checkIfDateIsBeforeToday }
        }
    },
    methods: {
        getResults(){
            this.$refs.searchParams.validate(async (valid) =>{
                if(valid){
                    const params = {
                        survey_uuid: this.searchParams.uuid,
                        date_range: this.searchParams.date
                    };
                    await this.$store.dispatch('campaign/getSurveyAnswers', params);
                }
            })

        },
        checkIfDateIsBeforeToday(time){
            return time.getTime() >= (new Date()).getTime() + 24*60*60*1000;
        }
    }
}